import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-724131fc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_Header = _resolveComponent("Header")
  const _component_el_header = _resolveComponent("el-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_Footer = _resolveComponent("Footer")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["side-container", { 'side-container_hide': _ctx.isCollapse }]
    }, [
      _createVNode(_component_el_scrollbar, null, {
        default: _withId(() => [
          _createVNode(_component_el_menu, {
            "collapse-transition": false,
            collapse: _ctx.isCollapse,
            uniqueOpened: false,
            "default-active": _ctx.activePath,
            "text-color": "#f4f4f5",
            "active-text-color": "#409eff",
            "background-color": "#304156",
            onSelect: _ctx.handleMenuSelect
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuData, (item) => {
                return (_openBlock(), _createBlock(_component_el_submenu, {
                  key: item.index,
                  index: item.index
                }, {
                  title: _withId(() => [
                    (item.icon)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: item.icon
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  default: _withId(() => [
                    (item.children)
                      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.children, (item) => {
                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: item.index,
                            index: item.index
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["collapse", "default-active", "onSelect"])
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_el_container, {
      style: { 'margin-left': _ctx.isCollapse ? '64px' : '210px' }
    }, {
      default: _withId(() => [
        _createVNode(_component_el_header, null, {
          default: _withId(() => [
            _createVNode(_component_Header, {
              user: _ctx.currentUser,
              isCollapse: _ctx.isCollapse,
              onHandleCollapse: _ctx.handleCollapse
            }, null, 8, ["user", "isCollapse", "onHandleCollapse"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withId(() => [
            _createVNode(_component_Footer)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style"])
  ], 64))
})